'use client'

import { usePermission } from '@/lib/hooks/use-permission'
import { useRole } from '@/lib/hooks/use-role'

interface PermissionGateProps {
  children: React.ReactNode
  permissions?: string | string[]
  roles?: string | string[]
  requireAll?: boolean
  fallback?: React.ReactNode
}

export function PermissionGate({
  children,
  permissions,
  roles,
  requireAll = false,
  fallback = null,
}: PermissionGateProps) {
  const hasPermissionAccess = usePermission(permissions || [])
  const hasRoleAccess = useRole(roles || [])

  let hasAccess: boolean

  // If both permissions and roles are specified
  if (permissions && roles) {
    hasAccess = requireAll
      ? hasPermissionAccess && hasRoleAccess
      : hasPermissionAccess || hasRoleAccess
  }
  // If only permissions are specified
  else if (permissions) {
    hasAccess = hasPermissionAccess
  }
  // If only roles are specified
  else if (roles) {
    hasAccess = hasRoleAccess
  }
  // If neither are specified, allow access
  else {
    hasAccess = true
  }

  if (!hasAccess) {
    return <>{fallback}</>
  }

  return <>{children}</>
}